import React from 'react';
import './Header.css';

interface HeaderProps {
  showLogo?: boolean;
  participantCount?: number;
  connectionStatus?: 'connected' | 'connecting' | 'disconnected';
  title?: string;
}

const Header: React.FC<HeaderProps> = ({
  showLogo = true,
  participantCount,
  connectionStatus = 'connected',
  title
}) => {


  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-center">
              <span className="logo-text">Dory</span>
        </div>
      </div>
    </header>
  );
};

export default Header; 